// Shared number/currency formatters used across the AI integration usage views.
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

// e.g. $1,234 (no decimals)
export const usd = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0
})

// e.g. $1.2K
export const usdCompact = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1
})

// e.g. $1.2K
// e.g. $24K (rounded, no decimals)
export const usdCompactWhole = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 0
})

// e.g. 1.2K
export const compact = new Intl.NumberFormat('en-US', {
  notation: 'compact',
  maximumFractionDigits: 1
})

// Cycle time and other durations stored in minutes -> "2d 4h" / "5h 12m" / "8m"
export const formatDurationMinutes = (minutes: number | null): string => {
  if (minutes == null) {
    return '—'
  }
  const d = dayjs.duration(Math.round(minutes), 'minutes')
  const totalDays = Math.floor(d.asDays())
  if (minutes < 60) {
    return `${Math.round(minutes)}m`
  }
  if (totalDays > 0) {
    return `${totalDays}d ${d.hours()}h`
  }
  return `${d.hours()}h ${d.minutes()}m`
}
